<template lang="html">
  <div class="mark-paper">
    <div class="mark-paper__header">
      <div class="mark-paper__title">画笔批改</div>
      <div class="buttons">
        <el-button @click="quit">退出批改</el-button>
        <el-button type="primary" @click="saveCanvas(false)">保存</el-button>
      </div>
    </div>
    <div class="mark-paper__container">
      <div class="mark-paper__thumb">
        <el-scrollbar class="mark-paper__scroll">
        <ul>
          <li v-for="(item, i) in fillImageList" :key="i" @click="changeCanvas(i)" :class="{active: i === selectIndex}">
            <span class="order" :class="{active: i === selectIndex}">{{i + 1}}</span>
            <span class="thumb__img"><img :src="item.teacher_answer_pic || item.answer_pic"></span>
            <span class="hasCorrected" v-if="item.teacher_answer_pic">已批注</span>
          </li>
        </ul>
        </el-scrollbar>
      </div>
      <div class="mark-paper__wrap">
        <div class="canvas__wrap" ref="wrap" id="canvas__wrap">
          <canvas id="canvas"></canvas>
        </div>
        <div class="tools">
          <div class="scale-tip">为保证学员端查看效果，仅能在100%的比例下进行批改</div>
          <div class="scale_canvas">
            <el-select v-model="scaleValue" @change="handleZoom" size="small" popper-class="customSelect">
              <el-option
                v-for="item in scaleOpts"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <span class="tag">缩放</span>
          </div>
          <div class="tools_box">
            <span @click="changeMode(MOVE_MODE)">
              <i class="icon move" :class="{active: CURRENT_MODE === MOVE_MODE}"></i>
              <i class="tag">移动</i>
            </span>
            <span @click="changeMode(PAINT_MODE)" :class="{disabled: scaleValue !== 1}">
              <i class="icon paint disabled" :class="{active: CURRENT_MODE === PAINT_MODE}"></i>
              <i class="tag">画笔</i>
            </span>
            <span @click="changeMode(ERASER_MODE)" :class="{disabled: scaleValue !== 1}">
              <i class="icon eraser" :class="{active: CURRENT_MODE === ERASER_MODE}"></i>
              <i class="tag">橡皮擦</i>
            </span>
            <!-- <span @click="changeMode(LINE_MODE)">
              <i class="icon line"></i>
              <i class="tag">划线</i>
            </span>
            <span @click="changeMode(ARROW_MODE)">
              <i class="icon arrow"></i>
              <i class="tag">箭头</i>
            </span>
            <span @click="changeMode(RECT_MODE)">
              <i class="icon rect"></i>
              <i class="tag">方框</i>
            </span> -->
            <el-popover
              placement="bottom"
              v-model="visible"
              popper-class="customPopover"
              trigger="click"
              :disabled="scaleValue !== 1">
              <div>
                <ul class="colors">
                  <li @click="changeColor(i)" v-for="(color, i) in colors" :key="i" :class="{active: lineColorIndex === i}"><span :style="{backgroundColor: color}"></span></li>
                </ul>
              </div>
              <span @click="changeMode(LINE_MODE)"  slot="reference" :class="{disabled: scaleValue !== 1}">
                  <i class="icon line" :class="{active: CURRENT_MODE === LINE_MODE}" style="border-right: solid 1px #e5e5e5;"></i>
                  <i class="tag">划线</i>
                </span>
            </el-popover>
            <el-popover
              placement="bottom"
              v-model="visible1"
              popper-class="customPopover"
              trigger="click"
              :disabled="scaleValue !== 1">
              <div>
                <ul class="colors">
                  <li @click="changeColor(i)" v-for="(color, i) in colors" :key="i" :class="{active: arrowColorIndex === i}"><span :style="{backgroundColor: color}"></span></li>
                </ul>
              </div>
              <span @click="changeMode(ARROW_MODE)"  slot="reference" :class="{disabled: scaleValue !== 1}">
                  <i class="icon arrow" :class="{active: CURRENT_MODE === ARROW_MODE}" style="border-right: solid 1px #e5e5e5;"></i>
                  <i class="tag">箭头</i>
                </span>
            </el-popover>
            <el-popover
              placement="bottom"
              v-model="visible2"
              popper-class="customPopover"
              trigger="click"
              :disabled="scaleValue !== 1">
              <div>
                <ul class="colors">
                  <li @click="changeColor(i)" v-for="(color, i) in colors" :key="i" :class="{active: rectColorIndex === i}"><span :style="{backgroundColor: color}"></span></li>
                </ul>
              </div>
              <span @click="changeMode(RECT_MODE)"  slot="reference" :class="{disabled: scaleValue !== 1}">
                  <i class="icon rect" :class="{active: CURRENT_MODE === RECT_MODE}" style="border-right: solid 1px #e5e5e5;"></i>
                  <i class="tag">方框</i>
                </span>
            </el-popover>
            <el-popover
              placement="bottom"
              v-model="visible3"
              popper-class="customPopover"
              trigger="click"
              :disabled="scaleValue !== 1">
              <div>
                <ul class="colors">
                  <li @click="changeColor(i)" v-for="(color, i) in colors" :key="i" :class="{active: tagColorIndex === i}"><span :style="{backgroundColor: color}"></span></li>
                </ul>
              </div>
              <span @click="changeMode(TAG_MODE)"  slot="reference" :class="{disabled: scaleValue !== 1}">
                  <i class="icon tag" :class="{active: CURRENT_MODE === TAG_MODE}" style="border-right: solid 1px #e5e5e5;"></i>
                  <i class="tag">标签</i>
                </span>
            </el-popover>
            <!-- <span @click="changeMode(TAG_MODE)">
              <i class="icon tag"></i>
              <i class="tag">标签</i>
            </span> -->
            <span @click="changeMode(HIGHLIGHT_MODE)" :class="{disabled: scaleValue !== 1}">
              <i class="icon highlight" :class="{active: CURRENT_MODE === HIGHLIGHT_MODE}"></i>
              <i class="tag">高亮</i>
            </span>
            <span @click="changeMode(COMMENTS_MODE)" :class="{disabled: scaleValue !== 1}">
              <i class="icon comments" :class="{active: CURRENT_MODE === COMMENTS_MODE}"></i>
              <i class="tag">批注</i>
            </span>
          </div>
          <div class="handle_box">
            <span @click="handleRotate(false)" :class="{disabled: scaleValue !== 1}">
              <i class="icon rotate"></i>
              <i class="tag">旋转</i>
            </span>
            <span @click="handleUndo" :class="{disabled: scaleValue !== 1}">
              <i class="icon cancel"></i>
              <i class="tag">撤销</i>
            </span>
            <span @click="clearCanvas" :class="{disabled: scaleValue !== 1}">
              <i class="icon clear"></i>
              <i class="tag">清空样式</i>
            </span>
          </div>
        </div>
        <!-- 附件 -->
        <div class="attachments" v-if="userAnswerList[currentIndex] && userAnswerList[currentIndex].answer_part && userAnswerList[currentIndex].answer_part.length > 0">
          <div class="left attachments-title">附件：</div>
          <div class="left" v-for="(item, index) in userAnswerList[currentIndex].answer_part" :key="index">
            <span v-if="Number(item.type) === 3 || Number(item.type) === 4" @click="viewAttachment(item)" class="attachmentIcon" :class="[attachmentType[Number(item.type)]]" slot="reference"></span>
            <span v-if="Number(item.type) === 5" @click="viewAttachment(item)" class="attachmentIcon" :class="[attachmentCustomType[item.customType]]" slot="reference"></span>
            <span v-if="Number(item.type) === 6"  class="attachmentIcon">
              <el-image
                style="width: 14px; height: 14px; position:absolute; top: 4px; left: 4px"
                :src="picImg"
                :preview-src-list="[item.content]">
              </el-image>
            </span>
          </div>
        </div>
        <!-- <button @click="save">保存</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import picImg from './img/attach/pic.png'
import { getURLBase64 } from '@/utils/getURLBase64'
import { SERVER_BASE_URL } from '@/api/api'
import { Loading, Message } from 'element-ui'
// import * as userAnswer from './mock.json'
// type: 作答内容类型, 1: 文字, 2: 批注, 3: 视频, 4: 音频, 5: 文档(包括word、pdf、压缩包等)
export default {
  props: ['userAnswer', 'ques_id'],
  data () {
    return {
      userAnswerList: [],
      attachmentListData: [],
      attachmentType: [
        '',
        '',
        '',
        'video',
        'audio',
        'other'
      ],
      attachmentCustomType: [
        'pdf',
        'word',
        'excel',
        'other'
      ],
      canvas: null,
      context: null,
      CURRENT_MODE: 0,
      MOVE_MODE: 0,
      PAINT_MODE: 1,
      ERASER_MODE: 2,
      LINE_MODE: 3,
      ARROW_MODE: 4,
      RECT_MODE: 5,
      RECT_MODE2: 11,
      TAG_MODE: 6,
      HIGHLIGHT_MODE: 7,
      COMMENTS_MODE: 8,
      tagList: [
        './img/1.png',
        './img/2.png',
        './img/3.png'
      ],
      currentTagIndex: 0,
      fillImageSrc: '',
      currentCanvasObj: [],
      currentIndex: 0,
      currentAngle: 0,
      bgScale: {
        scaleX: 1,
        scaleY: 1
      },
      scaleOpts: [
        {
          value: 0.5,
          label: '50%'
        },
        {
          value: 0.75,
          label: '75%'
        },
        {
          value: 1,
          label: '100%'
        },
        {
          value: 1.25,
          label: '125%'
        },
        {
          value: 1.5,
          label: '150%'
        },
        {
          value: 1.75,
          label: '175%'
        },
        {
          value: 2,
          label: '200%'
        }
      ],
      scaleValue: 1,
      bgOptions: {},
      originList: [
        {
          originX: 'left',
          originY: 'top'
        },
        {
          originX: 'left',
          originY: 'bottom'
        },
        {
          originX: 'right',
          originY: 'bottom'
        },
        {
          originX: 'right',
          originY: 'top'
        }
      ],
      fillImageList: [
        // {
        //   id: 1,
        //   canvasObj: null,
        //   originSrc: 'https://s.eoffcn.com/pigai/admin/img/202008/IG8VHtgPrvzsHkK9LvOmgqzSTNllFH4fmiNqkCyO.jpeg',
        //   src: 'http://cdn.algbb.cn/test/canvasTest.jpg',
        //   rotate: 0
        // },
        // {
        //   id: 2,
        //   canvasObj: null,
        //   originSrc: 'http://cdn.algbb.cn/test/canvasTest2.png',
        //   src: 'http://cdn.algbb.cn/test/canvasTest2.png',
        //   rotate: 0
        // },
        // {
        //   id: 3,
        //   canvasObj: null,
        //   originSrc: 'http://cdn.algbb.cn/emoji/30.png',
        //   src: 'http://cdn.algbb.cn/emoji/30.png',
        //   rotate: 0
        // }
        // {
        //   id: 4,
        //   canvasObj: [],
        //   originSrc: '1.png',
        //   src: '1.png'
        // }
      ],
      visible: false,
      visible1: false,
      visible2: false,
      visible3: false,
      isDrawingMode: false,
      mouseTo: {
        x: undefined,
        y: undefined
      },
      mouseFrom: {
        x: undefined,
        y: undefined
      },
      doDrawing: false,
      drawingObject: null,
      selectIndex: 0,
      fillStartPointX: 0,
      fillStartPointY: 0,
      colors: [
        '#ff3300',
        '#00ccff',
        '#66ff00',
        '#ffff00',
        '#666666',
        '#ffffff'
      ],
      lineColorIndex: 0,
      arrowColorIndex: 0,
      rectColorIndex: 0,
      tagColorIndex: 0,
      drawWidth: 2,
      tagNumList: [],
      tagColorsName: [
        'red',
        'blue',
        'green',
        'yellow',
        'grey',
        'white'
      ],
      lastZoom: 1,
      undo: [],
      state: undefined,
      undoStatus: false,
      client: null,
      picImg: picImg
    }
  },
  methods: {
    // 初始化canvas对象
    init () {
      this.wrap = document.getElementById('canvas__wrap')
      this.wrap.style.cursor = 'move'
      // 设置canvas样式
      const canvasWidth = window.getComputedStyle(this.$refs.wrap).width.slice(0, -2)
      const canvasHeight = window.getComputedStyle(this.$refs.wrap).height.slice(0, -2)
      this.c = document.getElementById('canvas')
      this.context = this.c.getContext('2d')

      this.c.width = canvasWidth
      this.c.height = canvasHeight

      this.handleCanvas(this.currentIndex)
    },
    // 初始化canvas
    async handleCanvas (index) {
      console.log(this.fillImageList[index])
      this.CURRENT_MODE = this.MOVE_MODE
      // this.currentIndex = index
      this.fillImageSrc = this.fillImageList[index].originSrc
      // debugger
      this.currentCanvasObj = this.fillImageList[index].canvasObj
      if (this.currentCanvasObj.tagNumList) {
        this.tagNumList = this.currentCanvasObj.tagNumList
      }

      console.log('................', this.currentCanvasObj)

      // if (this.currentCanvasObj.length > 0) {
      //   // fabric.Object.prototype.transparentCorners = false
      //   this.canvas.clear()
      //   this.canvas.loadFromJSON(this.currentCanvasObj, () => {
      //     this.canvas.renderAll()
      //   })
      //   return
      // }

      // 获取远程图片的宽高
      this.img = new Image()
      this.img.setAttribute('crossOrigin', 'Anonymous')
      this.img.src = await getURLBase64(this.fillImageSrc)
      console.log(1)
      this.img.onload = () => {
        console.log(this.img.width, this.img.height)
        // 新建一个canvas实例
        if (!this.canvas) {
          this.canvas = new fabric.Canvas('canvas', {
            backgroundColor: 'white'
          })
          this.canvas.defaultCursor = `move`
          this.handleEventListener()
        } else {
          this.canvas.clear()
        }
        // this.currentCanvasObj.backgroundImage = this.img.src

        // this.canvasArray = this.canvas.getObjects()
        // this.canvas.clear()
        // fabric.Object.prototype.transparentCorners = false
        this.isDrawingMode = false
        this.canvas.isDrawingMode = this.isDrawingMode
        this.canvas.defaultCursor = `move`
        this.canvas.hoverCursor = `move`
        this.canvas.skipTargetFind = false

        let { scaleX, scaleY } = this.bgScale
        let translateLeft = (this.canvas.width - this.img.width) / 2
        let translateTop = (this.canvas.height - this.img.height) / 2
        if (this.img.width > (this.canvas.width - 280) || this.img.height > (this.canvas.height - 480)) {
          scaleX = (this.canvas.width - 280) / this.img.width
          scaleY = (this.canvas.width - 280) / this.img.width
          translateLeft = (this.canvas.width - this.img.width * scaleX) / 2
          translateTop = (this.canvas.height - this.img.height * scaleX) / 2
        }
        this.bgOptions = {
          top: translateTop,
          left: translateLeft,
          scaleX: scaleX,
          scaleY: scaleY,
          // width: this.canvas.width,
          // height: this.canvas.height,
          originX: 'left',
          originY: 'top',
          angle: 0
        }

        this.canvas.loadFromJSON(this.currentCanvasObj)
        // console.log(this.fillImageList[this.currentIndex].answer_part, 'oooooooooooooooooooooooooooooooooooo')
        // for (let i = 0; i < this.fillImageList[this.currentIndex].answer_part.length; i++) {
        //   if (Number(this.fillImageList[this.currentIndex].answer_part[i].type) === 5) {
        //     if (this.fillImageList[this.currentIndex].answer_part[i].content.indexOf('.pdf') > -1) {
        //       this.fillImageList[this.currentIndex].answer_part[i].customType = 0
        //     } else if (this.fillImageList[this.currentIndex].answer_part[i].content.indexOf('.dox') > -1 || this.fillImageList[this.currentIndex].answer_part[i].content.indexOf('.docx') > -1) {
        //       this.fillImageList[this.currentIndex].answer_part[i].customType = 1
        //     } else if (this.fillImageList[this.currentIndex].answer_part[i].content.indexOf('.xls') > -1) {
        //       this.fillImageList[this.currentIndex].answer_part[i].customType = 2
        //     } else {
        //       this.fillImageList[this.currentIndex].answer_part[i].customType = 3
        //     }
        //   }
        // }
        // console.log(this.fillImageList[this.currentIndex].answer_part, 'ppppppppppppppppppppppppppppp')
        setTimeout(() => {
          if (this.fillImageList[this.currentIndex].rotate > 0) {
            this.handleRotate(this.fillImageList[this.currentIndex].rotate)
          } else {
            this.canvas.setBackgroundImage(
              this.img.src,
              this.canvas.renderAll.bind(this.canvas),
              this.bgOptions
            )
            this.renderCopyBtns(translateLeft, translateTop, scaleX)
          }
          this.canvasArray = this.currentCanvasObj.objects
          console.log(this.canvasArray)
          if (this.canvasArray && this.canvasArray.length > 0) {
            this.canvasArray.forEach((item) => {
              // 标签
              if (item.customType === 'tag') {
                // debugger
                const tagImg = `./img/${this.tagColorsName[item.colorIndex]}/${item.index + 1}.png`
                fabric.Image.fromURL(require(`${tagImg}`), (img) => {
                  let oImg = img.set({
                    left: item.left,
                    top: item.top,
                    customType: 'tag',
                    index: item.index,
                    hasControls: false
                  }).scale(0.5)
                  this.canvas.add(oImg)
                })
                // this.tagNumList[item.index] = true
              }
            })
          }
          setTimeout(() => {
            this.undo = []
            this.undo.push(this.canvas.toJSON())
            console.log(this.undo)
          }, 1000)
        }, 20)
      }
    },
    // 生成复制按钮
    renderCopyBtns (translateLeft, translateTop, scaleX) {
      $('.copyBtn').remove()
      for (let i  = 0; i < this.fillImageList[this.currentIndex].answer_part.length; i++) {
        let left = `${Number(this.fillImageList[this.currentIndex].answer_part[i].coordinates.top_left.x) * scaleX + translateLeft}`
        let top = `${Number(this.fillImageList[this.currentIndex].answer_part[i].coordinates.top_left.y) * scaleX + translateTop}`
        switch (this.currentAngle) {
          case 90:
            left = `${750 - (Number(this.fillImageList[this.currentIndex].answer_part[i].coordinates.top_left.y) * scaleX + translateLeft) - 16}`
            top = `${Number(this.fillImageList[this.currentIndex].answer_part[i].coordinates.top_left.x) * scaleX + translateTop}`
            break
          case 180:
            left = `${750 - (Number(this.fillImageList[this.currentIndex].answer_part[i].coordinates.top_left.x) * scaleX + translateLeft) - 16}`
            top = `${1334 - (Number(this.fillImageList[this.currentIndex].answer_part[i].coordinates.top_left.y) * scaleX + translateTop) - 16}`
            break
          case 270:
            left = `${Number(this.fillImageList[this.currentIndex].answer_part[i].coordinates.top_left.y) * scaleX + translateLeft}`
            top = `${1334 - (Number(this.fillImageList[this.currentIndex].answer_part[i].coordinates.top_left.x) * scaleX + translateTop) - 16}`
            break
          default:
            break
        }
        if (Number(this.fillImageList[this.currentIndex].answer_part[i].type) === 1 || Number(this.fillImageList[this.currentIndex].answer_part[i].type) === 2) {
          let copyBtn = `<div class="copyBtn"
            data-content="${encodeURI(this.fillImageList[this.currentIndex].answer_part[i].content)}"
            style="cursor:pointer;position:absolute;
            left:${Math.floor(left)}px;
            top:${Math.floor(top)}px;">
            <i class="el-icon-document-copy"></i>
            </div>`
          $('#canvas__wrap').append(copyBtn)
        }
      }
      // 复制
      $('.copyBtn').click((e) => {
        // console.log($(e.target).parent().children('textarea').val(), e.currentTarget.getAttribute('data-content'))
        let output = document.createElement('input')
        output.value = decodeURI(e.currentTarget.getAttribute('data-content'))
        output.style.position = 'absolute'
        output.style.zIndex = -1
        e.currentTarget.appendChild(output)
        output.select()
        document.execCommand('Copy')
        Message.success({
          message: '复制成功'
        })
      })
    },
    // 保存状态
    saveState () {
      // if (this.state) {
      //   this.undo.push(this.state)
      // }
      this.state = this.canvas.toJSON()
      this.undo.push(this.state)
      console.log('undo::', this.undo)
      // this.undo.push(this.state)
      console.log("state--->   ", this.state)
    },
    // 撤销
    handleUndo () {
      let canvasObjs = this.canvas.getObjects()
      console.log(canvasObjs)
      if (this.scaleValue !== 1) {
        return
      }
      this.undoStatus = true
      console.log(this.undo.length)
      console.log(this.undo)
      if (this.undo.length === 1) {
        return
      }
      if (this.undo.length === 2) {
        this.state = this.undo[0]
        console.log(this.state)
        this.undo.splice(this.undo.length - 1, 1)
        this.canvas.clear()
        this.canvas.loadFromJSON(this.state, () => {
          this.canvas.renderAll()
        })
        // //////////////////////
        if (canvasObjs[canvasObjs.length - 1].customType === 'tag') {
          this.tagNumList[canvasObjs[canvasObjs.length - 1].index] = false
        }
        this.canvasArray = this.state.objects
        console.log(this.canvasArray)
        if (this.canvasArray.length > 0) {
          // this.tagNumList = new Array(20).fill(false)
          this.canvasArray.forEach((item) => {
            // 标签
            if (item.customType === 'tag') {
              // debugger
              const tagImg = `./img/${this.tagColorsName[item.colorIndex]}/${item.index + 1}.png`
              fabric.Image.fromURL(require(`${tagImg}`), (img) => {
                let oImg = img.set({
                  left: item.left,
                  top: item.top,
                  customType: 'tag',
                  index: item.index,
                  hasControls: false
                }).scale(0.5)
                this.canvas.add(oImg)
              })
              this.tagNumList[item.index] = true
            }
          })
        }
        // /////////////////////
        return
      }
      if (canvasObjs[canvasObjs.length - 1].customType === 'tag') {
        this.tagNumList[canvasObjs[canvasObjs.length - 1].index] = false
      }
      this.state = this.undo.splice(this.undo.length - 2, 1)
      console.log(this.undo)
      console.log(this.state)
      // if (this.state[0].objects[this.state[0].objects.length - 1])
      if (this.state) {
        // this.canvas.clear()
        this.canvas.loadFromJSON(this.state[0], () => {
          this.canvas.renderAll()
        })
      }
      this.canvasArray = this.state[0].objects
      console.log(this.canvasArray)
      if (this.canvasArray.length > 0) {
        // this.tagNumList = new Array(20).fill(false)
        this.canvasArray.forEach((item) => {
          // 标签
          if (item.customType === 'tag') {
            // debugger
            const tagImg = `./img/${this.tagColorsName[item.colorIndex]}/${item.index + 1}.png`
            fabric.Image.fromURL(require(`${tagImg}`), (img) => {
              let oImg = img.set({
                left: item.left,
                top: item.top,
                customType: 'tag',
                index: item.index,
                hasControls: false
              }).scale(0.5)
              this.canvas.add(oImg)
            })
            this.tagNumList[item.index] = true
          }
        })
      }
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {type: mime})
    },
    // 生成日期目录
    getFolderName () {
      let date = new Date()
      return date.getFullYear() + ('0' + String(date.getMonth() + 1)).substr(-2) + date.getDate()
    },
    // 切换缩略图
    changeCanvas (index) {
      this.saveCanvas(true, index)
      // 保存切换前的数据
      // this.fillImageList[this.currentIndex].canvasObj = this.canvas.getObjects()
      // console.log(JSON.stringify(this.canvas.toJSON()))

      // let params = {
      //   exercise_id: 1,
      //   record_id: 22362,
      //   object_id: 6255,
      //   object_type: 1,
      //   question_id: 1211,
      //   canvas_obj: JSON.stringify(this.canvas.toJSON()),
      //   canvas_id: this.currentIndex,
      //   rotate: this.rotate,
      //   origin_src: this.fillImageList[this.currentIndex].answer_pic,
      //   now_src: this.canvas.toDataURL('image/jpeg'),
      //   sso_id: 2323
      // }
      // axios.post('http://pigai-d.t.eoffcn.com/api/admin/exercise/saveCorrectInfo', params).then((res) => {
      //   console.log(res)
      // })
      // this.$api.SAVECORRECTINFO({
      //   exercise_id: 1,
      //   record_id: 22362,
      //   object_id: 6255,
      //   object_type: 1,
      //   question_id: 1211,
      //   // canvas_obj: JSON.stringify(this.canvas.toJSON()),
      //   canvas_id: this.currentIndex,
      //   rotate: this.rotate,
      //   origin_src: this.fillImageList[this.currentIndex].answer_pic,
      //   // now_src: this.canvas.toDataURL('image/jpeg'),
      //   sso_id: 2323
      // }).then((res) => {
      //   console.log('cccccccccccccc', res)
      //   this.selectIndex = index
      //   this.handleCanvas(index)
      // })
      // console.log(this.fillImageList)
      // this.handleCanvas(index)
    },
    drawArrow (fromX, fromY, toX, toY, theta, headlen) {
      theta = typeof theta !== 'undefined' ? theta : 30
      headlen = typeof theta !== 'undefined' ? headlen : 10
      // 计算各角度和对应的P2,P3坐标
      var angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI
      var angle1 = (angle + theta) * Math.PI / 180
      var angle2 = (angle - theta) * Math.PI / 180
      var topX = headlen * Math.cos(angle1)
      var topY = headlen * Math.sin(angle1)
      var botX = headlen * Math.cos(angle2)
      var botY = headlen * Math.sin(angle2)
      var arrowX = fromX - topX
      var arrowY = fromY - topY
      var path = ' M ' + fromX + ' ' + fromY
      path += ' L ' + toX + ' ' + toY
      arrowX = toX + topX
      arrowY = toY + topY
      path += ' M ' + arrowX + ' ' + arrowY
      path += ' L ' + toX + ' ' + toY
      arrowX = toX + botX
      arrowY = toY + botY
      path += ' L ' + arrowX + ' ' + arrowY
      return path
    },
    transformMouse(mouseX, mouseY) {
      return { x: mouseX, y: mouseY };
    },
    drawing () {
      if (this.drawingObject) {
        this.canvas.remove(this.drawingObject);
      }
      var canvasObject = null
      switch (this.CURRENT_MODE) {
        case this.LINE_MODE:
          console.log(this.mouseFrom.x)
          let tt = (750 * this.scaleValue / 2 - this.mouseFrom.x) / this.scaleValue * (this.scaleValue - 1) + this.mouseFrom.x
          console.log(tt)
          let t = this.mouseFrom.x * this.scaleValue
          canvasObject = new fabric.Line([this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y], {
            stroke: this.colors[this.lineColorIndex],
            strokeWidth: this.drawWidth,
            scaleValue: this.scaleValue
          })
          break
        case this.HIGHLIGHT_MODE:
          canvasObject = new fabric.Line([this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y], {
            stroke: 'rgba(255,255,0, 0.3)',
            strokeWidth: 15,
            scaleValue: this.scaleValue
          })
          break
        case this.ARROW_MODE:
          canvasObject = new fabric.Path(this.drawArrow(this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y, 30, 30), {
            stroke: this.colors[this.arrowColorIndex],
            fill: 'rgba(255,255,255,0)',
            strokeWidth: this.drawWidth,
            scaleValue: this.scaleValue
          })
          break
        case this.RECT_MODE:
          var path =
            'M ' +
            this.mouseFrom.x +
            ' ' +
            this.mouseFrom.y +
            ' L ' +
            this.mouseTo.x +
            ' ' +
            this.mouseFrom.y +
            ' L ' +
            this.mouseTo.x +
            ' ' +
            this.mouseTo.y +
            ' L ' +
            this.mouseFrom.x +
            ' ' +
            this.mouseTo.y +
            ' L ' +
            this.mouseFrom.x +
            ' ' +
            this.mouseFrom.y +
            ' z'
          canvasObject = new fabric.Path(path, {
            left: this.mouseFrom.x,
            top: this.mouseFrom.y,
            stroke: this.colors[this.rectColorIndex],
            strokeWidth: this.drawWidth,
            fill: 'rgba(255, 255, 255, 0)',
            scaleValue: this.scaleValue
          })
          break
      }

      this.canvas.add(canvasObject)
      this.drawingObject = canvasObject
    },
    changeMode (mode) {
      if (this.scaleValue !== 1 && mode !== this.MOVE_MODE) {
        return
      }
      this.undoStatus = false
      this.CURRENT_MODE = mode
      switch (mode) {
        case this.MOVE_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `move`
          this.canvas.hoverCursor = `move`

          this.canvas.skipTargetFind = false
          // this.canvas.selectable = true
          // this.canvas.selection = true

          break
        case this.PAINT_MODE:
          this.isDrawingMode = true
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.freeDrawingBrush.color = 'red'
          this.canvas.freeDrawingBrush.width = 2 * this.scaleValue
          this.canvas.defaultCursor = `url('http://cdn.algbb.cn/pencil.ico') 6 26, pointer`
          this.canvas.hoverCursor = `url('http://cdn.algbb.cn/pencil.ico') 6 26, pointer`
          this.paintScale = this.scaleValue
          break
        case this.ERASER_MODE:
          this.canvas.discardActiveObject()
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          // this.canvas.freeDrawingBrush.color = null
          // this.canvas.freeDrawingBrush.width = 0

          this.canvas.selection = true
          this.canvas.skipTargetFind = false
          this.canvas.selectable = true

          this.canvas.defaultCursor = `url('http://cdn.algbb.cn/eraser.ico') 6 26, pointer`
          this.canvas.hoverCursor = `url('http://cdn.algbb.cn/eraser.ico') 6 26, pointer`
          break
        case this.LINE_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `crosshair`
          this.canvas.hoverCursor = `crosshair`
          this.canvas.skipTargetFind = true
          this.canvas.selectable = false
          this.canvas.selection = false
          break
        case this.ARROW_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `crosshair`
          this.canvas.hoverCursor = `crosshair`
          this.canvas.skipTargetFind = true
          this.canvas.selectable = false
          this.canvas.selection = false
          break
        case this.RECT_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `crosshair`
          this.canvas.hoverCursor = `crosshair`
          this.canvas.skipTargetFind = true
          this.canvas.selectable = false
          this.canvas.selection = false
          break
        case this.HIGHLIGHT_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `crosshair`
          this.canvas.hoverCursor = `crosshair`
          this.canvas.skipTargetFind = true
          this.canvas.selectable = false
          this.canvas.selection = false
          break
        case this.TAG_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `default`
          this.canvas.hoverCursor = `default`
          this.canvas.skipTargetFind = true
          this.canvas.selectable = false
          this.canvas.selection = false
          break
        case this.COMMENTS_MODE:
          this.isDrawingMode = false
          this.canvas.isDrawingMode = this.isDrawingMode
          this.canvas.defaultCursor = `default`
          this.canvas.hoverCursor = `default`
          break
        default:
          break
      }
    },
    // 清除
    onlyClearCanvas () {
      let thisCanvasObj = this.canvas.getObjects()
      if (thisCanvasObj.length === 0) {
        return
      }
      if (thisCanvasObj.length > 0) {
        thisCanvasObj.forEach((item) => {
          this.canvas.remove(item)
        })
      }
    },
    // 清除
    clearCanvas () {
      if (this.scaleValue !== 1) {
        return
      }
      let thisCanvasObj = this.canvas.getObjects()
      if (thisCanvasObj.length === 0) {
        return
      }
      this.$confirm('确定要清空所有样式吗？历史编辑也会被清空', '', {
        confirmButtonText: '清空样式',
        cancelButtonText: '继续编辑',
        type: 'warning'
      }).then(() => {
        // 遍历标注数组
        if (thisCanvasObj.length > 0) {
          thisCanvasObj.forEach((item) => {
            this.canvas.remove(item)
          })
        }
        this.$message({
          type: 'success',
          message: '清除成功!'
        })
      }).catch(() => {

      })
    },
    // 旋转
    handleRotate (currentAngle) {
      if (this.scaleValue !== 1) {
        return
      }
      if (currentAngle) {
        this.currentAngle = currentAngle
      } else {
        if (this.currentAngle === 270) {
          this.currentAngle = 0
        } else {
          this.currentAngle += 90
        }
      }
      let translateLeft = (this.canvas.width - this.img.width) / 2
      let translateTop = (this.canvas.height - this.img.height) / 2
      let { scaleX, scaleY } = this.bgScale
      // debugger
      if (this.currentAngle === 90 || this.currentAngle === 270) {
        translateLeft = Math.abs((this.canvas.width - this.img.height) / 2)
        translateTop = Math.abs((this.canvas.height - this.img.width) / 2)
        if (this.img.height > (this.canvas.width - 280) || this.img.width > (this.canvas.height - 480)) {
          scaleX = (this.canvas.width - 280) / this.img.height
          scaleY = (this.canvas.width - 280) / this.img.height
          translateLeft = (this.canvas.width - this.img.height * scaleX) / 2
          translateTop = (this.canvas.height - this.img.width * scaleY) / 2
        }
      } else {
        scaleX = (this.canvas.width - 280) / this.img.width
        scaleY = (this.canvas.width - 280) / this.img.width
        translateLeft = (this.canvas.width - this.img.width * scaleX) / 2
        translateTop = (this.canvas.height - this.img.height * scaleX) / 2
      }
      this.renderCopyBtns(translateLeft, translateTop, scaleX)

      const { originX, originY } = this.originList[this.currentAngle / 90]
      this.bgOptions.originX = originX
      this.bgOptions.originY = originY
      this.bgOptions.angle = this.currentAngle
      this.bgOptions.top = translateTop
      this.bgOptions.left = translateLeft
      this.bgOptions.scaleX = scaleX
      this.bgOptions.scaleY = scaleY
      this.canvas.setBackgroundImage(
        this.img.src,
        this.canvas.renderAll.bind(this.canvas),
        this.bgOptions
      )

    },
    // 缩放
    handleZoom (value) {
      document.getElementById('canvas__wrap').style.zoom = value
      if (value !== 1) {
        this.changeMode(this.MOVE_MODE)
        this.canvas.selections = false
      } else {
        this.canvas.selections = true
      }
      // this.canvas.setZoom(value)
      // const zoomX = this.canvas.width / 2
      // const zoomY = (this.canvas.height) / 2
      // let zoomPoint = new fabric.Point(zoomX, zoomY)
      // this.canvas.zoomToPoint(zoomPoint, value)
    },
    // 事件监听
    handleEventListener () {
      this.canvas.on('object:modified', () => {
        console.log('modified')
        this.saveState()
      })
      this.canvas.on('object:added', () => {
        console.log(this.undoStatus)
        if (this.undoStatus || this.CURRENT_MODE === this.LINE_MODE || this.CURRENT_MODE === this.ARROW_MODE || this.CURRENT_MODE === this.RECT_MODE || this.CURRENT_MODE === this.HIGHLIGHT_MODE) {
          console.log('return')
          return
        }
        console.log('add')
        this.saveState()
      })
      this.canvas.on('object:removed', () => {
        console.log('removed')
        if (this.CURRENT_MODE === this.LINE_MODE || this.CURRENT_MODE === this.ARROW_MODE || this.CURRENT_MODE === this.RECT_MODE || this.CURRENT_MODE === this.HIGHLIGHT_MODE) {
          return
        }
        this.saveState()
      })
      this.canvas.on('object:rotating', () => {
        console.log('rotating')
        this.saveState()
      })
      // 监听滚轮放大缩小
      document.addEventListener('mousewheel', (e) => {
        if (e.target.className === 'upper-canvas ') {
          this.scaleValue = (event.deltaY > 0 ? -0.25 : 0.25) + this.scaleValue
          if (this.scaleValue > 2) {
            this.scaleValue = 2
          } else if (this.scaleValue < 0.5) {
            this.scaleValue = 0.5
          }
          this.handleZoom(this.scaleValue)
        }
      })
      // ctrl + 0 恢复 100% 比例
      document.onkeydown = (event) => {
        let keyEvent = event || window.event || arguments.callee.caller.arguments[0]
        let ctrlKey = event.ctrlKey || event.metaKey
        if ((ctrlKey && keyEvent.keyCode === 48) || (ctrlKey && keyEvent.keyCode === 96)) {
          if (this.scaleValue !== 1) {
            this.scaleValue = 1
            this.handleZoom(this.scaleValue)
          }
        }
        // if (ctrlKey && keyEvent.keyCode === 187) {
        //   if (this.scaleValue >= 2) {
        //     this.scaleValue = 2
        //   } else {
        //     this.scaleValue = this.scaleValue + 0.25
        //   }
        //   this.handleZoom(this.scaleValue)
        //   event.preventDefault()
        // }
        // if (ctrlKey && keyEvent.keyCode === 189) {
        //   if (this.scaleValue <= 0.5) {
        //     this.scaleValue = 0.5
        //   } else {
        //     this.scaleValue = this.scaleValue - 0.25
        //   }
        //   this.handleZoom(this.scaleValue)
        //   event.preventDefault()
        // }
      }
      // 鼠标按下事件
      this.canvas.on('mouse:down', (e) => {
        console.log(e.target)
        console.log('down')
        if (this.CURRENT_MODE === 0 && !e.target) {
          this.panning = true
          this.canvas.selection = false

          this.downX = e.e.pageX
          this.downY = e.e.pageY
        } else if (this.CURRENT_MODE === this.LINE_MODE || this.CURRENT_MODE === this.ARROW_MODE || this.CURRENT_MODE === this.RECT_MODE || this.CURRENT_MODE === this.HIGHLIGHT_MODE) {
          this.panning = false
          let xy = this.transformMouse(e.e.offsetX, e.e.offsetY)
          this.mouseFrom.x = xy.x
          this.mouseFrom.y = xy.y
          this.doDrawing = true
        } else if (this.CURRENT_MODE === this.COMMENTS_MODE) {
          let xy = this.transformMouse(e.e.offsetX, e.e.offsetY)
          let textbox = new fabric.Textbox(' ', {
            left: xy.x,
            top: xy.y,
            width: 240,
            height: 140,
            fontSize: 14,
            borderColor: '#fff390',
            editingBorderColor: '#fff390',
            border: 1,
            hasBorders: true,
            fill: '#b79a3d',
            hasControls: false,
            selection: true,
            selectable: true,
            skipTargetFind: false,
            backgroundColor: '#fefbc5'
          })
          this.canvas.add(textbox)
          this.canvas.setActiveObject(textbox)
        } else if (this.CURRENT_MODE === this.TAG_MODE) {
          console.log(this.tagNumList)
          let ifMaximum = this.tagNumList.every((bool) => {
              return bool === true
          })
          if (ifMaximum) {
            this.$message({
              message: '标签数已达到上限',
              type: 'warning'
            })
            return
          }
          let currentTagNum = 0
          for (let i = 0; i < this.tagNumList.length; i++) {
            if (!this.tagNumList[i]) {
              currentTagNum = i
              this.tagNumList[i] = true
              break
            }
          }
          console.log(this.tagNumList)
          let xy = this.transformMouse(e.e.offsetX, e.e.offsetY)
          const tagImg = `./img/${this.tagColorsName[this.tagColorIndex]}/${currentTagNum + 1}.png`
          fabric.Image.fromURL(require(`${tagImg}`), (img) => {
            let oImg = img.set({
              customType: 'tag',
              index: currentTagNum,
              colorIndex: this.tagColorIndex,
              left: xy.x - 10,
              top: xy.y - 10,
              hasControls: false
            }).scale(0.5)
            oImg.toObject = () => {
              let customObj = {
                // ...oImg.toObject(),
                customType: 'tag',
                index: currentTagNum,
                colorIndex: this.tagColorIndex,
                left: xy.x - 10,
                top: xy.y - 10,
                hasControls: false
              }
              return customObj
            }
            console.log(oImg.toObject())
            this.canvas.add(oImg)
            // setTimeout(() => {
            //   this.saveState()
            // }, 200)
            // console.log(this.canvas.getObjects(), JSON.stringify(this.canvas.getObjects()))
            // if (this.currentTagIndex < this.tagList.length) {
            //   this.currentTagIndex++
            // }
          })
        }
      })
      // 移动画布事件
      this.canvas.on('mouse:move', (e) => {
        if (this.CURRENT_MODE === 0 && this.panning && !e.target) {
          this.moveX = e.e.pageX
          this.moveY = e.e.pageY
          this.translatePointX = this.fillStartPointX + (this.moveX - this.downX)
          this.translatePointY = this.fillStartPointY + (this.moveY - this.downY)
          this.wrap.style.transform = `translate(${this.translatePointX}px,${this.translatePointY}px)`
        } else if (this.CURRENT_MODE === this.LINE_MODE || this.CURRENT_MODE === this.ARROW_MODE || this.CURRENT_MODE === this.RECT_MODE || this.CURRENT_MODE === this.HIGHLIGHT_MODE) {
          if (!this.doDrawing) {
            // 减少绘制频率
            return
          }
          // moveCount++;
          var xy = this.transformMouse(e.e.offsetX, e.e.offsetY)
          this.mouseTo.x = xy.x
          this.mouseTo.y = xy.y
          this.drawing()
        }
      })
      // 鼠标抬起事件
      this.canvas.on('mouse:up', (e) => {
        this.undoStatus = false
        this.panning = false
        // this.canvas.selection = true
        if (this.CURRENT_MODE === 0 && !e.target) {
          this.upX = e.e.pageX
          this.upY = e.e.pageY
          this.fillStartPointX = this.fillStartPointX + (this.upX - this.downX)
          this.fillStartPointY = this.fillStartPointY + (this.upY - this.downY)
        } else if (this.CURRENT_MODE === this.COMMENTS_MODE) {
          this.changeMode(this.MOVE_MODE)
        } else if (this.CURRENT_MODE === this.LINE_MODE || this.CURRENT_MODE === this.ARROW_MODE || this.CURRENT_MODE === this.RECT_MODE || this.CURRENT_MODE === this.HIGHLIGHT_MODE) {
          var xy = this.transformMouse(e.e.offsetX, e.e.offsetY)
          this.mouseTo.x = xy.x
          this.mouseTo.y = xy.y
          // drawing();
          this.drawingObject = null
          // moveCount = 1;
          this.doDrawing = false
          this.saveState()
        }
      })
      const removeCanvasItem = (obj) => {
        if (obj.target._objects) {
          // 多选删除
          var etCount = obj.target._objects.length
          for (let etindex = 0; etindex < etCount; etindex++) {
            if (obj.target._objects[etindex].customType === 'tag') {
              this.tagNumList[obj.target._objects[etindex].index] = false
            }
            this.canvas.remove(obj.target._objects[etindex])
          }
        } else {
          // 单选删除
          // debugger
          if (obj.target.customType === 'tag') {
            this.tagNumList[obj.target.index] = false
          }
          this.canvas.remove(obj.target)
        }
        this.canvas.discardActiveObject() // 清除选中框
      }
      this.canvas.on('selection:created', (e) => {
        document.onkeydown = (event) => {
          let keyEvent = event || window.event || arguments.callee.caller.arguments[0]
          if ((keyEvent && keyEvent.keyCode === 8) || (keyEvent && keyEvent.keyCode === 46)) {
            if ((keyEvent && keyEvent.keyCode === 8) && e.target.type === 'textbox') {
              return
            }
            removeCanvasItem(e)
          }
        }
        console.log(e.target)
        console.log('select')
        if (this.CURRENT_MODE === this.ERASER_MODE) {
          removeCanvasItem(e)
          // if (e.target._objects) {
          //   // 多选删除
          //   var etCount = e.target._objects.length
          //   for (let etindex = 0; etindex < etCount; etindex++) {
          //     if (e.target._objects[etindex].type === 'tag') {
          //       this.tagNumList[e.target._objects[etindex].index] = false
          //     }
          //     this.canvas.remove(e.target._objects[etindex])
          //   }
          // } else {
          //   // 单选删除
          //   if (e.target.type === 'tag') {
          //     this.tagNumList[e.target.index] = false
          //   }
          //   this.canvas.remove(e.target)
          // }
          // this.canvas.discardActiveObject() // 清除选中框
        }
        console.log('selection:created')
      })
    },
    save () {
      console.log(this.canvas.toDataURL())
    },
    changeColor (index) {
      switch (this.CURRENT_MODE) {
        case this.LINE_MODE:
          this.lineColorIndex = index
          break
        case this.ARROW_MODE:
          this.arrowColorIndex = index
          break
        case this.RECT_MODE:
          this.rectColorIndex = index
          break
        case this.TAG_MODE:
          this.tagColorIndex = index
          break
        default:
          break
      }
    },
    draw () {
      // var canvas = new fabric.Canvas('canvas', {
      //   isDrawingMode: true
      // })
      this.isDrawingMode = true
      this.canvas.isDrawingMode = this.isDrawingMode
      this.canvas.freeDrawingBrush.color = 'red'
    },
    addTag () {
      this.isDrawingMode = false
      this.canvas.isDrawingMode = this.isDrawingMode
    },
    // 保存
    saveCanvas (ifChange, index) {
      // ifChange 为true时是保存并切换,index 为要切换的下一个下标   ifChange 为 false时保存成功并关闭
      this.fillImageList[this.currentIndex].canvasObj = this.canvas.getObjects()
      // 保存
      this.loadingInstance = Loading.service({ fullscreen: true, text: '加载中', background: 'rgba(0,0,0,0.5)' })
      let folderUrl = `/pigai/exercise/${this.getFolderName()}/${Math.floor(Math.random() * 10000) + 1}`
      this.client.multipartUpload(folderUrl, this.dataURLtoBlob(this.canvas.toDataURL('image/jpeg'))).then((result) => {
        // 生成下载地址
        let url = `https://s.eoffcn.com${folderUrl}`
        console.log(url)
        let finalCanvas = this.canvas.toJSON()
        finalCanvas.backgroundImage = null
        // finalCanvas.tagNumList = this.tagNumList = new Array(20).fill(false)
        finalCanvas.tagNumList = this.tagNumList
        console.log(finalCanvas, 'oooooooooooooooooooo', this.tagNumList)
        let params = {
          exercise_id: this.$route.params.exercise_id, // 1
          record_id: this.$route.params.record_id, // 22362
          object_id: this.$route.params.object_id, // 6255
          object_type: this.$route.params.object_type, // 1
          question_id: this.$route.params.comment_object_id, // this.ques_id, // 1211
          canvas_obj: JSON.stringify(finalCanvas),
          canvas_id: this.currentIndex,
          rotate: this.currentAngle,
          origin_src: this.fillImageList[this.currentIndex].answer_pic,
          now_src: url,
          sso_id: this.$route.params.sso_id, // 2323
          correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
        }
        window.sso.ready().then(user => {
          axios.post(SERVER_BASE_URL + '/api/admin/exercise/saveCorrectInfo', params).then((res) => {
            console.log(res)
            this.loadingInstance.close()
            if (res.data.retcode === 0) {
              if (ifChange) {
                this.currentIndex = index
                this.selectIndex = index
                this.getCanvasInfo(false)
              } else {
                // document.body.style.overflow = 'auto'
                this.$emit('closeCanvas')
              }
            } else {
              Message.error({
                message: res.data.message || '保存出错'
              })
            }
          }).catch((error) => {
            Message.error({
              message: '保存出错'
            })
            this.loadingInstance.close()
            // console.log(error)
            if (error.response) {
              window.sso.ready().then(user => {
                if(!user.isNotLogin(error.response.status,error.response.headers)){
                    console.log('网络不给力，请稍后重试');
                }
              });
            } else {
              console.log('Error', error.message);
            }
          })
        }).catch((err) => {
          this.loadingInstance.close()
          console.log(err)
          Message.error({
            message: '上传图片至OSS出错'
          })
        })
      });
    },
    // 退出批改
    quit () {
      this.$confirm('退出批改将不会保存已经批改的内容，确定退出吗？', '', {
          confirmButtonText: '确定退出',
          cancelButtonText: '继续批改',
          type: 'warning'
        }).then(() => {
          // document.body.style.overflow = 'auto'
          this.$emit('closeCanvas')
        }).catch(() => {
        })
    },
    // 查看 下载附件
    // viewAttachment (url) {
    //   if (url.indexOf('m3u8') > -1) {
    //     let arr = url.split('/')
    //     let vidoe_window = window.open('')
    //     let href =  this.$router.resolve({
    //       path: '/video-preview/' + arr[arr.length - 2]
    //     })
    //     vidoe_window.location = href.href
    //   } else {
    //     window.open(url)
    //   }
    // },
    // 查看 下载附件
    // type: 作答内容类型, 1: 文字, 2: 批注, 3: 视频, 4: 音频, 5: 文档(包括word、pdf、压缩包等)
    viewAttachment (item) {
      const url = item.content
      const mediaId = item.media_id
      if (Number(item.type) === 4 || Number(item.type) === 3) {
        let vidoe_window = window.open('')
        let href =  this.$router.resolve({
          path: '/video-preview/' + mediaId
        })
        vidoe_window.location = href.href
      } else {
        window.open(url)
      }
    },
    getOssToken () {
      this.$api.GETOSSTOKEN({}).then(res => {
        const { AccessKeyId, AccessKeySecret, Expiration, SecurityToken } = res
        const OSS = require('ali-oss')
        this.client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: AccessKeyId,
          accessKeySecret: AccessKeySecret,
          stsToken: SecurityToken,
          bucket: 's-eoffcn-com'
        })
      })
    },
    getCanvasInfo (init) {
      let params = {
        exercise_id: this.$route.params.exercise_id,
        record_id: this.$route.params.record_id,
        question_id: this.$route.params.comment_object_id, // this.ques_id,
        canvas_id: this.currentIndex,
        correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
      }
      this.$api.GETCANVASINFO(params).then(res => {
        console.log(res)
        if (res.retcode === 0) {
          if (init) {
            this.fillImageList = this.userAnswerList.map((item, i) => {
              return {
                answer_pic: item.answer_pic,
                teacher_answer_pic: item.teacher_answer_pic,
                answer_part: item.answer_part,
                originSrc: item.answer_pic
              }
            })
          }
          if (res.data && res.data.canvas_obj) {
            this.fillImageList[this.currentIndex].canvasObj = JSON.parse(res.data.canvas_obj)
          } else {
            this.fillImageList[this.currentIndex].canvasObj = {}
          }
          if (res.data && res.data.rotate) {
            this.fillImageList[this.currentIndex].rotate = res.data.rotate
            this.currentAngle = res.data.rotate
          } else {
            this.fillImageList[this.currentIndex].rotate = 0
            this.currentAngle = 0
          }
          console.log('>>>>>>>>>>>>>>>>>', this.fillImageList)
          this.init()
        } else if (res.retcode === 10001) {
          if (init) {
            this.fillImageList = this.userAnswerList.map((item, i) => {
              return {
                answer_pic: item.answer_pic,
                answer_part: item.answer_part,
                originSrc: item.answer_pic
              }
            })
            this.fillImageList[this.currentIndex].canvasObj = {}
            this.fillImageList[this.currentIndex].rotate = 0
            this.currentAngle = 0
          }
          this.init()
        }
      })
    }
  },
  created () {
    this.tagNumList = new Array(20).fill(false)
    console.log(this.tagNumList)
    this.getOssToken()
    this.userAnswerList = JSON.parse(this.userAnswer)
    this.userAnswerList.forEach((item) => {
      if (item.answer_part) {
        item.answer_part.forEach((onepart) => {
          if (Number(onepart.type) === 5) {
            if (onepart.content.indexOf('.pdf') > -1) {
              onepart.customType = 0
            } else if (onepart.content.indexOf('.dox') > -1 || onepart.content.indexOf('.docx') > -1) {
              onepart.customType = 1
            } else if (onepart.content.indexOf('.xls') > -1) {
              onepart.customType = 2
            } else {
              onepart.customType = 3
            }
          }
        })
      }
    })
    console.log('userAnswer:::::', this.userAnswerList)
  },
  mounted () {
    // document.body.style.overflow = 'hidden'
    this.getCanvasInfo(true)
    // this.$api.GETEXERCISEPAPERREPORT({
    //   record_id: 22362,
    //   object_id: 6255
    // }).then((res) => {
    //   console.log(res.data.list[1].question_list[1].user_answer)
    //   let user_answer = JSON.parse(res.data.list[1].question_list[1].user_answer)
    //   if (user_answer.length > 0) {
    //     this.fillImageList = user_answer.map((item) => {
    //       return {
    //         answer_pic: item.answer_pic,
    //         answer_part: item.answer_part,
    //         originSrc: item.answer_pic,
    //         canvasObj: null
    //       }
    //     })
    //   }
    //   console.log(222222222222222222, this.fillImageList[this.currentIndex].answer_part)
    //   this.init()
    // })

    // 鼠标按下事件
    // canvas.on("mouse:down", function(e) {
    //   // console.log(e.target)
    //   if (!this.isDrawingMode) {
    //     if (!e.target) {
    //       this.panning = true;
    //       canvas.selection = false;
    //     }
    //   }
    // });
    // // //鼠标抬起事件
    // canvas.on("mouse:up", function(e) {
    //   this.panning = false;
    //   canvas.selection = true;
    // });
    // canvas.on("selection:cleared", function(e) {
    //   console.log('selection:cleared')
    // });
    // canvas.on("selection:created", function(e) {
    //   console.log('selection:created')
    //   setTimeout(() => {
    //     console.log(canvas.getObjects());
    //     canvas.remove(e.target)
    //     console.log(canvas.getObjects());
    //   }, 2000);
    // });
    // canvas.on("selection:updated", function(e) {
    //   console.log('selection:updated')
    // });
    // // // 移动画布事件
    // canvas.on("mouse:move", function(e) {
    //   if (!this.isDrawingMode) {
    //     if (this.panning && e && e.e) {
    //       var delta = new fabric.Point(e.e.movementX, e.e.movementY);
    //       canvas.relativePan(delta);
    //     }
    //   }
    // });
    // // 鼠标滚动放大缩小画布
    // //
    // if (document.getElementById("canvas")) {
    //   // IE9, Chrome, Safari, Opera
    //   document.addEventListener("mousewheel", function(e) {
    //     if (e.target.className == "upper-canvas ") {
    //       var zoom = (event.deltaY > 0 ? -0.1 : 0.1) + canvas.getZoom();
    //       zoom = Math.max(0.1, zoom); //最小为原来的1/10
    //       zoom = Math.min(3, zoom); //最大是原来的3倍
    //       var zoomPoint = new fabric.Point(event.pageX, event.pageY);
    //       canvas.zoomToPoint(zoomPoint, zoom);
    //     }
    //   });
    // }
  }
}
</script>

<style lang="less" scoped>
.mark-paper{
  height: 100%;
  min-width: 880px;
  .el-button{
    padding: 9px 17px;
    &.el-button--primary{
      background-color: #6594fe;
    }
    &.el-button--default{
      color: #7d829a;
      border: solid 1px #e5e5e5;
    }
  }
}
.mark-paper{
  &__header{
    overflow: hidden;
    height: 59px;
    line-height: 59px;
    box-shadow: 0px 1px 0px 0px #e5e5e5;
    background-color: #ffffff;
    padding: 0px 20px;
    .mark-paper__title{
      float: left;
      font-size: 16px;
      font-weight: bold;
      color: #2a2e3d;
    }
    .buttons{
      float: right;
    }
  }
  &__container{
    display: flex;
    height: calc(100% - 59px);
  }
  &__thumb{
    flex: 0 0 130px;
    height: 100%;
    background-color: #f2f2f2;
    border-right: 1px solid #cccbcb        ;
    // overflow: auto;
    ul{
      list-style: none;
      padding: 0;
      margin:6px 0 0 0;
      li{
        padding: 5px 10px 5px 0;
        width: 100%;
        overflow: hidden;
        cursor: pointer;
        text-align: center;
        display: flex;
        align-items: flex-end;
        position: relative;
        .hasCorrected{
          position: absolute;
          left: 23px;
          top: 5px;
          display: inline-block;
          width: 53px;
          height: 23px;
          text-align: center;
          line-height: 23px;
          color: #ff6600;
          z-index: 2;
          font-size: 12px;
          background: #fff2e8;
        }
        &.active{
          background-color: #6594fe;
        }
        // justify-content:center;
        span{
          display: inline-block;
          &.order{
            font-size: 12px;
            color: #838c96;
            padding-left: 11px;
            padding-right: 5px;
            &.active{
              color: #ffffff;
            }
          }
          &.thumb__img{
            width: 96px;
            height: 72px;
            overflow: hidden;
            background-color: #ffffff;
            box-shadow: 0px 0px 5px 0px rgba(229, 229, 229, 0.5);
            border-radius: 2px;
            display: flex;
            align-items: flex-start;
            justify-content:center;
            img{
              max-width: 100%;
            }
          }
        }
      }
    }
  }
  &__scroll{
    height: 100%;
    .el-scrollbar__wrap{
      // overflow-x: hidden;
      overflow-y: auto;
    }
  }
  &__wrap{
    flex:1;
    background-color: #e0e0e0;
    position: relative;
    overflow: hidden;
    .canvas__wrap{
      position: absolute;
      left: 50%;
      margin-left: -375px;
      width: 750px;
      height: 1334px;
      overflow: hidden;
      // margin: auto;
      background: #ffffff;
    }
    .tools{
      position: absolute;
      left: 0;
      top: 42px;
      height: 50px;
      width: 100%;
      // overflow: hidden;
      display: flex;
      justify-content:center;
      span{
        cursor: pointer;
      }
      .scale-tip{
        width: 737px;
        position: absolute;
        left: 50%;
        margin-left: -363px;
        top: -25px;
        font-size: 14px;
      }
      .scale_canvas{
        width: 80px;
        height: 100%;
        position: relative;
        margin: 0 10px;
        .el-input__inner{
          height: 30px!important;
        }
        .tag{
          position: absolute;
          top: 33px;
          left: 50%;
          margin-left: -10px;
          font-size: 14px;
          color: #2a2e3d;
        }
      }
      .tools_box{
        height: 32px;
        text-align: center;
        border-radius: 4px;
        margin: 0 10px;
        border: solid 1px #e5e5e5;
        span{
          width: 50px;
          height: 30px;
          float: left;
          outline: 0;
          &.disabled{
            opacity: 0.5;
            cursor: not-allowed;
          }
          i{
            display: block;
            width: 50px;
            font-style: normal;
            &.icon{
              height: 30px;
              background-color: #ffffff;
              background-repeat: no-repeat;
              background-position: center;
              &.move{
                background-image: url('./img/move.png');
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/move_on.png');
                }
              }
              &.paint{
                background-image: url('./img/paint.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/paint_on.png');
                }
              }
              &.eraser{
                background-image: url('./img/eraser.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/eraser_on.png');
                }
              }
              &.line{
                background-image: url('./img/line.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/line_on.png');
                }
              }
              &.arrow{
                background-image: url('./img/arrow.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/arrow_on.png');
                }
              }
              &.rect{
                background-image: url('./img/rect.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/rect_on.png');
                }
              }
              &.tag{
                background-image: url('./img/tag.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/tag_on.png');
                }
              }
              &.highlight{
                background-image: url('./img/highlight.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/highlight_on.png');
                }
              }
              &.comments{
                background-image: url('./img/comments.png');
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                &:hover, &.active{
                  background-image: url('./img/comments_on.png');
                }
              }
            }
            &.tag{
              display: block;
              text-align: center;
              font-size: 14px;
              color: #2a2e3d;
              padding-top: 2px;
            }
          }
        }
      }
      .handle_box{
        height: 32px;
        text-align: center;
        border-radius: 4px;
        border: solid 1px #e5e5e5;
        margin: 0 10px;
        span{
          width: 50px;
          height: 30px;
          float: left;
          &.disabled{
            opacity: 0.5;
            cursor: not-allowed;
          }
          &:last-child{
            width: 60px;
            i{
              width: 60px;
            }
          }
          i{
            display: block;
            width: 50px;
            font-style: normal;
            &.icon{
              height: 30px;
              background-color: #ffffff;
              background-repeat: no-repeat;
              background-position: center;
              &.rotate{
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
                background-image: url('./img/rotate.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/rotate_on.png');
                }
              }
              &.cancel{
                background-image: url('./img/cancel.png');
                border-right: solid 1px #e5e5e5;
                &:hover, &.active{
                  background-image: url('./img/cancel_on.png');
                }
              }
              &.clear{
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                background-image: url('./img/clear.png');
                &:hover, &.active{
                  background-image: url('./img/clear_on.png');
                }
              }
            }
            &.tag{
              display: block;
              text-align: center;
              font-size: 14px;
              color: #2a2e3d;
              padding-top: 2px;
            }
          }
        }
      }
    }
    .attachments{
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -375px;
      width: 750px;
      height: 60px;
      line-height: 60px;
      font-weight: bold;
      background: rgba(0,0,0, 0.2);
      overflow: hidden;
      .left{
        float: left;
        .attachmentIcon{
          width: 24px;
          height: 24px;
          background-color: #fafafa;
          border-radius: 4px;
          border: solid 1px #e6e7e8;
          background-position: center;
          background-repeat: no-repeat;
          display: inline-block;
          cursor: pointer;
          margin-left: 10px;
          position: relative;
          top: 7px;
          &.pic{
            background-image: url("./img/attach/pic.png");
            &:hover{
              background-image: url("./img/attach/pic_on.png");
            }
          }
          &.video{
            background-image: url("./img/attach/video.png");
            &:hover{
              background-image: url("./img/attach/video_on.png");
            }
          }
          &.audio{
            background-image: url("./img/attach/audio.png");
            &:hover{
              background-image: url("./img/attach/audio_on.png");
            }
          }
          &.word{
            background-image: url("./img/attach/word.png");
            &:hover{
              background-image: url("./img/attach/word_on.png");
            }
          }
          &.excel{
            background-image: url("./img/attach/excel.png");
            &:hover{
              background-image: url("./img/attach/excel_on.png");
            }
          }
          &.pdf{
            background-image: url("./img/attach/pdf.png");
            &:hover{
              background-image: url("./img/attach/pdf_on.png");
            }
          }
          &.other{
            background-image: url("./img/attach/other.png");
            &:hover{
              background-image: url("./img/attach/other_on.png");
            }
          }
        }
      }
      .attachments-title{
        margin-left: 30px;
      }
    }
  }
}
.colors{
  list-style-type: none;
  padding: 0;
  margin: 0;
  overflow: hidden;
  li{
    width: 20px;
    height: 20px;
    border: 1px solid #cccccc;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    margin: 0 2px;
    &:hover, &.active{
      border: 1px solid #000000;
    }
    span{
      display: block;
      width: 16px;
      height: 16px;
      padding: 1px;
      background: red;
    }
  }
}

  canvas {
      // border: 1px dashed black;
  }
</style>



// WEBPACK FOOTER //
// src/pages/mark-paper/index.vue